<template>
    <section class="tiw__step-wrapper">
        <template v-if="isShowCloseMenu">
            <Button variant="unset" class="tiw__step-wrapper__close">
                <CloseIcon />
            </Button>
            <CloseMenu />
        </template>
        <div class="tiw__step-wrapper__header">
            <slot name="header"></slot>
        </div>
        <div class="tiw__step-wrapper__content">
            <slot></slot>
        </div>
        <footer v-if="!TIWStore.IS_INIT_WIDGET_LOADING" class="tiw__step-wrapper__footer">
            <div v-if="TIWStore.showHelpCrunchChat" class="footer-help">
                <p>
                    <ChatIcon class="chat-icon" />

                    {{ useTranslate("tiw__crunch__needHelp") }}

                    <template v-if="TIWStore.domainIsTakealot || TIWStore.domainIsAvoAfrica">
                        <span
                            @click="openCrunch"
                            v-html="useTranslate('tiw__crunch__liveChatUs')"
                        ></span>
                        {{ useTranslate("tiw__crunch__willAssistYou") }}
                    </template>
                    <template v-else>
                        <span @click="openCrunch" v-html="useTranslate('tiw__crunch__contactUs')" />
                        <!-- {{ useTranslate("tiw__crunch__contactUsAfter") }} -->
                    </template>
                </p>
            </div>
            <div class="footer-cont">
                <span>Powered by</span>
                <BreezyIcon />
            </div>
        </footer>
    </section>
</template>

<script lang="ts">
export default {
    name: "ModalComponent",
};
</script>

<script setup lang="ts">
/**
 * * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [Modal]
 * Модальное окно / обертка
 */

import CloseMenu from "@/components/closeMenu/closeMenu.vue";
// Store
import { useTIWStore } from "@/stores/tiw/tiw";
// Components
import Button from "@/ui/button/button.vue";
import BreezyIcon from "@/ui/icons/breezy.vue";
import ChatIcon from "@/ui/icons/chat.vue";
// Icon
import CloseIcon from "@/ui/icons/close.vue";
import useTranslate from "~/tiw/hooks/useTranslate/useTranslate";

const { isShowCloseMenu = true } = defineProps<{ isShowCloseMenu?: boolean }>();

const TIWStore = useTIWStore();

const openCrunch = () => {
    HelpCrunch("openChat");
};
</script>

<style lang="scss" src="./modal.scss"></style>
